const elements = document.querySelectorAll('[data-focal-x][data-focal-y]');
[...elements].forEach(el => {
    const x = el.dataset.focalX;
    const y = el.dataset.focalY;
    
    if(x && y) {
        el.style.backgroundPosition = `${x * 100}% ${y * 100}%`;
    }
});


// WEBPACK FOOTER //
// ./themes/wild/assets/js/focal.js